import axiosInstance from '../axiosInterceptor/axiosInstance'

const getAgeRestriction = async () => {
  const url = '/teams/age-restrictions'
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getAgeRestriction
